const config = {
    'numberOfNotificationEachTimeRendered': 5,
    'numberOfNotificationFromApi': 25,
    'customReqHeaders' : {
        'appVersion' : {
            'key' : 'cambridgeone-app-version',
            'value' : 'v2'
        }
    },
    'appSetting' : {
        'sessionStorage': {
            'announcement' : {
                'key' : "comprodls.nemo.serviceAnnouncement",
                'cachingTime': 1800000
            },
        },
        'localStorage' : {
            'announcement' : {
                'key' : "comprodls.nemo.closedAnnouncements",
            }
        }
    }
};
module.exports = config;